module.exports = __webpack_public_path__ + "static/media/Moon Waltz (2nd Movement) - Piano Version.371d17c9.jpg";